import { render, staticRenderFns } from "./tap5.vue?vue&type=template&id=00215fd8&scoped=true&"
import script from "./tap5.vue?vue&type=script&lang=js&"
export * from "./tap5.vue?vue&type=script&lang=js&"
import style0 from "./tap5.vue?vue&type=style&index=0&id=00215fd8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00215fd8",
  null
  
)

export default component.exports